import type { RouteRecordRaw } from 'vue-router';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const bannerManagementRoutes = {
  name: 'banner-management',
  path: 'banner-management',
  component: () => import('./BannerManagement.vue'),
  meta: { i18n },
} satisfies RouteRecordRaw;
